import { bool, node, string } from 'prop-types';

export const RatingsAndReviewsPropTypes = {
  /*
    This is a bad practice.
    APIs should not be called directly.
    There is a story to refactor this to use a graphql mutation:
    https://www.pivotaltracker.com/story/show/173363061
  */
  apiKey: string,
  children: node,
  collectionId: string,
  itemId: string.isRequired,
  prosAndCons: bool,
  forceCondensedLayout: bool,
  target: string,
};

export const RatingsAndReviewsDefaultProps = {
  apiKey: 'x5w9jA8tWVGcqRhujrHTvjRwQfH8MkFc',
  children: null,
  collectionId: null,
  prosAndCons: false,
  forceCondensedLayout: false,
  target: '',
  pageNumber: 1
};
